/**
 * Whether people see the ways to the Personas page, /settings/personas (docs/PLAN-assets-everywhere-20261025.md §H,
 * AE13a): its link on the settings page, in both designs, and its entry in the account menu. The one lever:
 * `REACT_APP_PERSONAS_ACCOUNTS`, a list of workspace ids where `*` admits every resolved workspace. Off when absent;
 * deploy.yml ships it as `*` (`vars.PERSONAS_ACCOUNTS` narrows or, naming no workspace, hides the page). The personas
 * themselves are decided on the server (`ops/assets.personas`, and `personas.view` on the person's member record), which
 * answers `off` or `hidden` whatever this says: hiding the ways in hides only where people open the page.
 */
import { buildEnv } from '../../config/buildEnv';

export const PERSONAS_ACCOUNTS_ENV = 'REACT_APP_PERSONAS_ACCOUNTS';

export function personasPageShows(
  accountId: string | null | undefined,
  env: Record<string, string | undefined> = buildEnv(),
): boolean {
  const account = String(accountId ?? '').trim();
  if (!account) return false;
  const listed = String(env[PERSONAS_ACCOUNTS_ENV] ?? '').split(',').map((s) => s.trim());
  return listed.includes('*') || listed.includes(account);
}
